let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9skoV")).then(() => parcelRequire('7v6Xe'));